import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { USER_LIST, USER_DETAILS, UserContext, CommonContext } from './../constant/ActionTypes';
import { userReducer } from './../reducer/userReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    userList: [],
    userDetails: {}
}

const UserProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [userState, dispatch] = useReducer(userReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    // get question list
    const getUserList = (page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`UserService/getAll${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: USER_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearUserList = () => {
        dispatch({
            type: USER_LIST,
            payload: []
        });
    }

    // get question list
    const getUserDetails = (user_id) => {
        api({ contentType: true, auth: true }).get(`UserService/getDetails/${user_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: USER_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // add user
    const addUser = (userdetail) => {
        setShowLoader(true);
		let data = {
			firstname: userdetail.firstname,
            lastname: userdetail.lastname,
            phone: userdetail.phone,
            email: userdetail.email,
            country: userdetail.country,
            city: userdetail.city
        }
        api({ contentType: true, auth: true }).post('UserService/add', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getUserList(1, 25);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }
    
    // get question list
    const updateUserDetails = (userdetail,user_id) => {
        setShowLoader(true);
        let data = {
            id: user_id,
            firstname: userdetail.firstname,
            lastname: userdetail.lastname,
            email: userdetail.email,
            phone: userdetail.phone,
            country: userdetail.country,
            city: userdetail.city
        }
        api({ contentType: true, auth: true }).patch('UserService/update', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getUserList(1, 25);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    // delete user
    const deleteUser = (user_id) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`UserService/delete/${user_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
				getUserList(1, 25);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    return (
        <UserContext.Provider
            value={{
                ...userState,
                getUserList: getUserList,
                getUserDetails: getUserDetails,
                updateUserDetails: updateUserDetails,
                deleteUser: deleteUser,
                addUser: addUser,
                clearUserList: clearUserList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </UserContext.Provider>
    );
}

export default UserProvider;



// WEBPACK FOOTER //
// ./contexts/provider/UserContext.js